const HTTP_HEADER_SOUND_CLIENT_KEY = "x-sound-client-key";
const HTTP_HEADER_SOUND_WEBAPP_VERSION = "x-sound-webapp-version";
const HTTP_HEADER_SOUND_CLIENT_JWT = "x-sound-client-jwt";
const HTTP_HEADER_SOUND_IDEMPOTENCY_ID = "x-sound-request-idempotency-id";
const HTTP_HEADER_SOUND_INTERNAL_API_TOKEN = "x-sound-internal-api-token";
const HTTP_HEADER_USER_AGENT = "user-agent";

export { HTTP_HEADER_SOUND_CLIENT_JWT, HTTP_HEADER_SOUND_CLIENT_KEY, HTTP_HEADER_SOUND_IDEMPOTENCY_ID, HTTP_HEADER_SOUND_INTERNAL_API_TOKEN, HTTP_HEADER_SOUND_WEBAPP_VERSION, HTTP_HEADER_USER_AGENT };
